export const IMPERSONATE_PATH = "/impersonate";
